import { useTheme as useNextTheme } from 'next-themes';

export function useTheme() {
  const { theme, setTheme, systemTheme, resolvedTheme } = useNextTheme();

  const setSystemTheme = () => {
    setTheme('system');
  };

  const setLightTheme = () => {
    setTheme('light');
  };

  const setDarkTheme = () => {
    setTheme('dark');
  };

  return {
    theme,
    setTheme,
    systemTheme,
    resolvedTheme,
    setSystemTheme,
    setLightTheme,
    setDarkTheme,
    isDark: resolvedTheme === 'dark',
    isSystemTheme: theme === 'system',
  };
}
